import React from 'react';
import Card from '../../shared/card';
import "./card-panel.css";
import { t, getCurrentLanguage, getModalContent } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class CardPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        const { currentLanguage } = this.state;
        
        return (
            <div className="card-panel">
                <div className="card-panel-title-group">
                    <h4 className="card-panel-product-name">{t('linha_protheus', currentLanguage)}</h4>
                    <h1 className="card-panel-title">{t('destaques_principais', currentLanguage)} 12.1.2510</h1>
                </div>
                <div className="card-panel-content">
                    <Card 
                        text={t('reforma_tributaria', currentLanguage)} 
                        link="https://espacolegislacao.totvs.com/protheus-reforma-tributaria/"
                    />
                    <Card 
                        text={t('implementacoes_seguranca', currentLanguage)} 
                        modalContent={getModalContent('implementacoes_seguranca_modal', currentLanguage)}
                    />
                    <Card 
                        text={t('recomendacoes_hardware', currentLanguage)} 
                        link="https://tdn.totvs.com/pages/viewpage.action?pageId=563437610"
                    />
                    <Card 
                        text={t('descontinuacao_ctree', currentLanguage)} 
                        link="https://tdn.totvs.com.br/pages/viewpage.action?pageId=990764038"
                    />
                    <Card 
                        text={t('acesso_rapido', currentLanguage)} 
                        link="https://tdn.totvs.com/x/jtE6Ow"
                    />
                    <Card 
                        text={t('protheus_insights', currentLanguage)} 
                        link="https://tdn.totvs.com/display/PROT/Protheus+Insights"
                    />
                </div>
            </div>
        );
    }
};

export default CardPanel;